import { NgFor } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';
import { KENDO_LABELS } from '@progress/kendo-angular-label';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment';
// 75624
@Component({
    selector: 'gd-radio',
    template: `
    <div [formGroup]="form">
      <div
        class="form-check"
        *ngFor="let opt of field.options"
        style="display:inline; padding:0px 5px 5px 20px"
      >
        <input
          class="form-check-input"
          (click)="valueChanged(opt.key)"
          [name]="field.name"
          type="radio"
          [formControlName]="field.name"
          [value]="opt.key"
        />
        <label class="form-check-label">
          {{ opt.label }}
        </label>
      </div>
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        KENDO_INPUTS, KENDO_LABELS,
    ]
})
export class RadioComponent implements OnChanges, OnInit {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  @Output() checkVals = new EventEmitter()
  public checkRoleisRep: boolean
  isDisabled = true
  ngOnInit() {
    const storageValue =
      localStorage.getItem('rrolelisted') == undefined
        ? ''
        : localStorage.getItem('rrolelisted')
    const paramTR = CryptoJS.AES.decrypt(
      storageValue,
      environment.securepw,
    ).toString(CryptoJS.enc.Utf8)
    const paramsVal = {
      role: paramTR,
    }
    let decodedString = decodeURIComponent(paramsVal.role)
    const alertRepControl = this.form.get('AlertRep');

    if (decodedString === 'REP') {
      if (alertRepControl !== null) {
      alertRepControl.disable();
      }
    } else {
      if (alertRepControl !== null) {
      alertRepControl.enable();
    }
  }
  }

  ngOnChanges() {
    if (
      this.field.name.toLowerCase() === 'alertrep' &&
      this.field.value === null
    ) {

      this.form.get('AlertRep').setValue('false')
    }
  }

  valueChanged(k: any) {
    const unsavedText = localStorage.getItem('UnsavedAlertText')
    if (k === true) {
      if (unsavedText !== null && unsavedText !== '') {
        this.form.get('AlertRepText').setValue(unsavedText)
      }
    } else {
      const currentRepAlert = this.form.get('AlertRepText')?.value
      if (currentRepAlert !== null && currentRepAlert !== '') {
        localStorage.setItem('UnsavedAlertText', currentRepAlert)
      }
    }

    this.checkVals.emit(k)
  }
}
